import {UserAccount} from "./custom-models/user-account";
import {AccessDomain} from "./access-domain";
export class User {
    userId: number;
    primaryEmail: string;
    isPrimaryEmailPersonal: boolean;
    alternateEmail: string;
    isAlternateEmailPersonal: boolean;
    personalEmail: string;
    currentOrgEmail: string;
    multiAssociation: boolean;
    givenName: string;
    firstName: string;
    lastName: string;
    middleName: string;
    locale: string;
    city: string;
    highestEducation: string;
    secondHighestEducation: string;
    gender: number;
    ageRange: number;
    lastUpdatedDateTime: any;
    role: string;
}


export class UserDetailsResponse {
    user: UserDetailsObject;
}

export class UserDetailsObject{
    ageRange: number;
    lastName: string;
    role: string;
    city: string;
    chatPassword: string;
    chatUserName: string;
    createdDateTime: number;
    highestEducation: number;
    locale: string;
    accessDomains: AccessDomain[];
    currentOrgEmail: string;
    personalEmail: string;
    isAlternateEmailPersonal: boolean;
    primaryEmail: string;
    alternateEmail: string;
    secondHighestEducation: string;
    givenName: string;
    timeZone: string;
    multiAssociation: boolean;
    userId: number;
    firstName: string;
    fkCountryId: Country;
    userAccount: UserAccount[];
    middleName: string;
    lastUpdatedDateTime: number;
    isPrimaryEmailPersonal: boolean;
    imageData: string;
}

export interface Country {
    countryId: number;
    countryName: string;
    isoCountryCode: string;
    createdDateTime: number;
    lastUpdatedDateTime: number;
}